import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { popup } from '../../addons/Popup';
import { store } from '../../App/store';
import { getAsync } from '../../utils/api';
import { mapDispatchSet } from '../../utils/redux';

export type ItemData = {
  order?: number;
  pageIndex?: number;
  formId: string;
  products: {
    name: string;
    pickupArea: string;
    count: number;
  }[];
  customer: {
    name: string;
    phones: string[];
    address: string;
  };
};

const initialState = {
  itemDatas: [] as ItemData[],
};

export const deliveryPaperSlice = createSlice({
  name: "delivery-paper",
  initialState,
  reducers: {
    updatePageItem: (
      state,
      action: PayloadAction<{
        formId: string;
        order: number;
        pageIndex: number;
      }>
    ) => {
      const { payload } = action;
      const itemIndex = state.itemDatas.findIndex(
        (id) => id.formId === payload.formId
      );

      console.log(payload);

      if (itemIndex >= 0) {
        const itemData = { ...state.itemDatas[itemIndex]! };
        itemData.order = payload.order;
        itemData.pageIndex = payload.pageIndex;

        state.itemDatas.splice(itemIndex, 1);
        state.itemDatas.push(itemData);
      }
    },

    addItem: (state, action: PayloadAction<ItemData>) => {
      state.itemDatas.push(action.payload);
    },

    removeItem: (state, action: PayloadAction<string>) => {
      const formId = action.payload;
      const index = state.itemDatas.findIndex((id) => id.formId === formId);

      if (index >= 0) {
        state.itemDatas.splice(index, 1);
      }
    },
  },
});

export const toggleItem = async (formId: string) => {
  const state = store.getState().deliveryPaper;

  if (state.itemDatas.find((id) => id.formId === formId)) {
    actions.removeItem(formId);
  } else {
    const formRes = await getAsync("/forms/get?id=" + formId);

    if (!formRes.success) {
      popup("Hata: Form yüklenemedi");
      return;
    }

    const formData = formRes.data;
    const accountRes = await getAsync(
      `/accounts/get?id=${formData.account.id}&versionId=${formData.account.versionId}`
    );

    if (!accountRes.success) {
      popup("Hata: Hesap yüklenemedi");
      return;
    }

    const accountData = accountRes.data;
    const itemData: ItemData = {
      formId,
      products: formData.products.map((prod: any) => ({
        count: prod.count,
        name: prod.productInfo.name,
        pickupArea: "",
      })),
      customer: {
        name: accountData.name,
        phones: accountData.phones.map((p: string) => p.replace("+90 ", "")),
        address: accountData.shipmentAddress,
      },
    };

    actions.addItem(itemData);
  }
};

export const actions = mapDispatchSet(deliveryPaperSlice.actions);
